
import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { Settings } from "lucide-react";

export const CookieSettings = () => {
  const { openSettings } = useCookieConsent();

  return (
    <Button 
      onClick={openSettings} 
      variant="ghost" 
      size="sm" 
      className="text-gray-400 hover:text-white text-xs px-2 h-7"
    >
      <Settings size={14} className="mr-1" />
      Cookie Settings
    </Button>
  );
};

export default CookieSettings;
